export default function PhotoVortexIcon(props) {
  const logotypeColor = "#000000";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
      stroke={logotypeColor}
      strokeWidth="2"
      {...props}
    >
      <rect
        x="4"
        y="4"
        width="92"
        height="92"
        rx="19"
        fill="white"
        stroke="white"
      />
      <path
        d="M50 10 
        C70 10, 90 30, 90 50 
        C90 70, 70 90, 50 90 
        C30 90, 10 70, 10 50 
        C10 30, 30 10, 50 10 
        M50 20 
        C65 20, 80 35, 80 50 
        C80 65, 65 80, 50 80 
        C35 80, 20 65, 20 50 
        C20 35, 35 20, 50 20"
      />
      <circle cx="50" cy="50" r="6" fill={logotypeColor} />
    </svg>
  );
}
